/**
 * Module « formules » — FOR-01 à FOR-05.
 *
 * Liste et CRUD des formules d’une saison, composition des séries imposées,
 * lien optionnel à une zone. Voir `PageFormules.tsx` pour l’écran, `hooks.ts`
 * pour les appels TanStack Query, `natures.ts` pour le vocabulaire des trois
 * natures (le point de confusion n°1 du domaine).
 */

import { lazy } from 'react'
import type { RouteObject } from 'react-router'

const PageFormules = lazy(() => import('./PageFormules').then((m) => ({ default: m.PageFormules })))

export const routesFormules: RouteObject[] = [
  {
    index: true,
    element: <PageFormules />,
  },
]
